import React from "react";
import { useMutation, useQueryClient } from "react-query";
import { useCookie } from "../../../hooks/useCookie";
import { useToast } from "../../../hooks/useToast";
import { general } from "../../../locales/general";
import apiService from "../../../service/apiService";
import { TranslationRow, TranslationTable } from "../Translationtableparts";

function TableBodyRowContent({
  packTranslation,
  deletedList,
}: {
  packTranslation: PackTranslation;
  deletedList: React.Dispatch<BulkDeleteActions>;
}) {
  const { toastSuccess, toastError } = useToast();
  const { token } = useCookie("vToken");
  const queryClient = useQueryClient();

  const deletePackTranslation = useMutation((id: string) => {
    return apiService.MakeDeleteRequest(`pack-translations/${id}`, token);
  });

  const removePackTranslation = () => {
    deletePackTranslation.mutate(packTranslation.id, {
      onError(error) {
        console.log(error);
        toastError(general.fr.message.operationFailed);
      },
      onSuccess() {
        toastSuccess(general.fr.message.partnerDeleted);
        queryClient.invalidateQueries("getAllTranslations");
      },
    });
  };

  return (
    <TranslationRow
      id={packTranslation.id}
      deletedList={deletedList}
      withImage
      image={packTranslation.pack?.image}
      sourceTitle={packTranslation.pack?.title}
      translation={packTranslation?.title}
      lang={packTranslation?.lang}
      editTo={`/pack-translations/update/${packTranslation.id}`}
      onDelete={removePackTranslation}
      isDeleting={deletePackTranslation.isLoading}
    />
  );
}

interface TableProps {
  packTranslations: PackTranslation[];
  packTranslationsToBeDeleted: React.Dispatch<BulkDeleteActions>;
}

export default function PackTranslationsTable({
  packTranslations,
  packTranslationsToBeDeleted,
}: TableProps) {
  return (
    <TranslationTable sourceLabel="Pack">
      {packTranslations?.map((packTranslation) => (
        <TableBodyRowContent
          packTranslation={packTranslation}
          key={packTranslation?.id}
          deletedList={packTranslationsToBeDeleted}
        />
      ))}
    </TranslationTable>
  );
}
